import React from 'react';
import { isPlatformLevel } from '../utils/roleUtils';
import PlatformDashboard from './platform/PlatformDashboard';
import TcDashboard from './dashboard/TcDashboard';

/**
 * /dashboard — platform roles get the Platform Admin KPI dashboard; everyone in a typing centre gets the
 * TC dashboard v2 (Operations · Finance · Performance & Team, TC-DASHBOARD-V2-DESIGN).
 */
const Dashboard = ({ currentUser }) => (
  isPlatformLevel(currentUser?.role)
    ? <PlatformDashboard currentUser={currentUser} />
    : <TcDashboard currentUser={currentUser} />
);

export default Dashboard;
